import React, {FC} from "react"

import Flex from "@irati/ui/src/Flex"
import Success from "@irati/ui/src/Success"
import Button from "@irati/ui/src/Button"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import {FormattedMessage} from "@irati/utils/lang"
import {Body} from "@irati/ui/src/Typography"
import Spacing from "@irati/ui/src/Spacing"

interface FailedUser {
  email: string
  message: string
}

interface Props {
  message?: string
  backLink?: string
  onClick?: () => void
  failedUsers?: FailedUser[]
  failedMessage?: string
}

const SuccessWithBackLink: FC<Props> = ({message, backLink, onClick, failedUsers, failedMessage}) => {
  return (
    <Flex direction="column" justifyContent="center">
      <Success message={message} />
      <Flex justifyContent="center">
        {backLink ? (
          <ButtonRouterLink to={backLink} onClick={onClick}>
            <FormattedMessage id="admin.components.success.close" />
          </ButtonRouterLink>
        ) : (
          <Button onClick={onClick}>
            <FormattedMessage id="admin.components.success.close" />
          </Button>
        )}
      </Flex>
      {failedUsers && failedUsers.length > 0 && (
        <Spacing marginTop={2}>
          <Body marginBottom={1}>
            <FormattedMessage id={failedMessage} />
          </Body>
          {failedUsers.map((user) => (
            <Body>{`${user.email}: ${user.message}`}</Body>
          ))}
        </Spacing>
      )}
    </Flex>
  )
}

export default SuccessWithBackLink
